export default __webpack_public_path__ + "static/media/input_agency-step3.efdd79a8.webp";